import React from "react";
import { FaStar } from "react-icons/fa6";
import "../../styles/BrandStrip.css";

export default function BrandStrip() {
  const items = [
    "Residential Cleaning",
    "Office Cleaning",
    "End of Lease",
    "Premium Quality",
    "Trusted Professionals",
    "Eco-Friendly",
    "24/7 Support",
    "Australian Owned"
  ];

  return (
    <section className="brand-strip-section">
      <div className="marquee-wrapper">
        <div className="marquee-content">
          {/* First set of items */}
          {items.map((item, index) => (
            <div key={`first-${index}`} className="marquee-item">
              <FaStar className="marquee-icon" />
              <span>{item}</span>
            </div>
          ))}
          {/* Duplicate set for seamless looping */}
          {items.map((item, index) => (
            <div key={`second-${index}`} className="marquee-item">
              <FaStar className="marquee-icon" />
              <span>{item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}